<vm-contact-us-shell
  [uid]="strapiUID"
  [routerLinkText]="routerLinkText"
  [routerLinkHref]="routerLinkHref"
  [enableBackLink]="enableBackLink"
  [chatbotId]="chatbotId"
  [hasPriorityCall]="ivrPriority"
  (next)="onContinue($event)"
  (openSecondaryModal)="openCallUsDialog()">
</vm-contact-us-shell>
